import styled from 'styled-components';

import { colours } from 'themes/default';

export const Container = styled.div`
  padding: 16px;
`;

export const Heading = styled.div`
  display: flex;
  align-items: center;

  > *:not(:first-child) {
    margin: 0 0 0 10px;
    color: ${colours.Greyscale.CharcoalGrey};
  }
`;

export const Content = styled.div`
  padding: 12px 15px;
  margin: 12px 0 0 0;
  border-radius: 4px;
`;
